import { MedicalServiceWizardService } from '../../../services/wizard/medical-service/medical-service-wizard';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { Component, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { MedicalAppointmentCareStudyDelivery } from '../../../model/medical-appointment-care-edit-info';
import { MatDialog } from '@angular/material';
import { StudyReportLogisticsCommentDialogComponent } from '../../dialogs/study-report-logistics-comment-dialog/study-report-logistics-comment-dialog.component';
import { StudyRegionFilter } from '../../../model/study-report/study-region-filter';
import { CacheFilterService } from '../../../services/cache/cache-filter.service';
import { MedicalServiceService } from 'src/app/services/medical-service.service';

@Component({
  selector: 'app-medical-service-study-delivery',
  templateUrl: './medical-service-study-delivery.component.html',
  styleUrls: ['./medical-service-study-delivery.component.css']
})

export class MedicalServiceStudyDeliveryComponent implements OnInit, WizardStep {

  completed: boolean;
  isInit: boolean;
  loading: boolean;
  displayColumns = [ 'Region', 'StudyDeliverDate', 'ReportPhysician', 'LogisticsComment' ];
  dataSource = new BehaviorSubject<AbstractControl[]>([]);
  form: FormGroup;
  physicianFilters: PhysicianFilter[];
  studyRegions: StudyRegionFilter[] = [];

  constructor(private medicalServiceWizardService: MedicalServiceWizardService
    , private formBuilder: FormBuilder
    , private dialog: MatDialog
    , private medicalServiceService: MedicalServiceService
    , private notificationToastService: NotificationToastService) {
      this.physicianFilters = [];
      this.form = this.formBuilder.group({
        MedicalAppointmentCareStudyDeliveries: this.formBuilder.array([])
      });

      this.medicalAppointmentCareStudyDeliveries.valueChanges.subscribe(() => {
        this.medicalServiceWizardService
            .setMedicalAppointmentCareStudyDeliveries(
              <MedicalAppointmentCareStudyDelivery[]>this.medicalAppointmentCareStudyDeliveries.getRawValue());
      });
  }

  get medicalAppointmentCareStudyDeliveries() { return <FormArray>this.form.get('MedicalAppointmentCareStudyDeliveries'); }

  activate(): void {

  }

  save(): void {

  }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    try {
      this.loading = true;

      this.physicianFilters = await this.medicalServiceWizardService
                                        .getPosibleReportPhysicianFilters();

      this.studyRegions = await this.medicalServiceService.getStudyRegionFilter();

      const info = await this.medicalServiceWizardService.getMedicalAppointmentCareEditInfo();

      console.log(info);

      info.MedicalAppointmentCareStudyDeliveries.forEach((item) => {

        console.log(item);

        let reportPhysician: PhysicianFilter;
        let studyRegion: StudyRegionFilter;

        if (item.ReportPhysician) {
          reportPhysician = this.physicianFilters.find(p => p.Id === item.ReportPhysician.Id);
        }

        if (item.StudyRegion) {
          studyRegion = this.studyRegions.find(p => p.Id === item.StudyRegion.Id);
        }

        const row = this.formBuilder.group({
          StudyRegion: [ studyRegion ],
          StudyReportId: [item.StudyReportId],
          ReportPhysician: [reportPhysician],
          StudyDeliverDate: [item.StudyDeliverDate]
        });
        this.medicalAppointmentCareStudyDeliveries.push(row);
        this.dataSource.next(this.medicalAppointmentCareStudyDeliveries.controls);
      });
      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Paciente');
    } finally {
      this.loading = false;
    }
  }

  displayRegionName(index: number): string {
    return this.medicalAppointmentCareStudyDeliveries.controls[index].value.Region;
  }

  openLogisticsCommnetEdit(index: number) {

       this.dialog.open(StudyReportLogisticsCommentDialogComponent, {
        width: '50%',
        data: { studyReportId:this.medicalAppointmentCareStudyDeliveries.controls[index].value.StudyReportId }
      });
  }
}
